module.exports = __webpack_public_path__ + "prod/1.42.2/img/obj_platform2x.edf50314.png";